import { Box, CardContent, Typography, styled } from '@mui/material';

export const StyledCardContent = styled(CardContent)({
  padding: '24px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledHeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '4px',
});

export const StyledTitleContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const StyledCompanyLogo = styled('img')({
  maxWidth: 128,
  maxHeight: 64,
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
});

export const StyledTagsContainer = styled(Box)({
  marginBottom: '8px',
});

export const StyledFeaturesContainer = styled(Box)({
  marginBottom: '16px',
});

export const StyledFeaturesTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.brand.primary,
  marginTop: '16px',
  marginBottom: '16px',
}));

export const StyledFeaturesList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const StyledSeeAllContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '8px',
});

export const StyledSeeAllText = styled(Typography)({
  textAlign: 'center',
});
